import { SvgIconProps } from '@mui/material';

export function SurchargeTreeIcon(props: SvgIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.1698 10.0603H7.82983C6.64983 10.0603 6.23983 9.27031 6.92983 8.31031L11.0998 2.47031C11.5898 1.77031 12.4098 1.77031 12.8998 2.47031L17.0698 8.31031C17.7598 9.27031 17.3498 10.0603 16.1698 10.0603Z"
        fill="#FF796E"
      />
      <path
        d="M17.5901 17.9996H6.41009C4.83009 17.9996 4.29009 16.9496 5.22009 15.6696L9.21009 10.0596H14.7901L18.7801 15.6696C19.7101 16.9496 19.1701 17.9996 17.5901 17.9996Z"
        fill="#FF796E"
      />
      <path
        d="M12.75 18V22C12.75 22.41 12.41 22.75 12 22.75C11.59 22.75 11.25 22.41 11.25 22V18H12.75Z"
        fill="#FF796E"
      />
    </svg>
  );
}

export default SurchargeTreeIcon;
